import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3 pt-0" }
const _hoisted_2 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_3 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_4 = { class: "col-sm-8" }
const _hoisted_5 = { class: "row mt-2" }
const _hoisted_6 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_7 = { class: "col-sm-8" }
const _hoisted_8 = { class: "row mt-3" }
const _hoisted_9 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_10 = { class: "col-sm-8" }
const _hoisted_11 = { class: "mb-1 ps-3 small text-muted" }
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = { class: "p-0 m-0" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "me-2" }
const _hoisted_18 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_19 = { class: "col-sm-12" }
const _hoisted_20 = { class: "d-flex flex-wrap gap-3 mb-2" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "alert alert-info py-2 px-3"
}
const _hoisted_23 = {
  key: 1,
  class: "alert alert-warning py-2 px-3"
}
const _hoisted_24 = { class: "fw-semibold mb-1" }
const _hoisted_25 = { class: "small text-break" }
const _hoisted_26 = {
  key: 2,
  class: "alert alert-danger py-2 px-3"
}
const _hoisted_27 = { class: "fw-semibold mb-1" }
const _hoisted_28 = { class: "small text-break" }
const _hoisted_29 = {
  key: 3,
  class: "alert alert-danger py-2 px-3 mb-0"
}
const _hoisted_30 = {
  class: "mb-0 ps-3",
  style: {"max-height":"180px","overflow":"auto"}
}
const _hoisted_31 = { class: "small text-muted mt-3 mb-0" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.importText('title'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.isVisible,
    "footer-class": "d-flex justify-content-end gap-2",
    "onUpdate:modelValue": _ctx.onVisibleChange
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        class: "h-100"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (!_ctx.allowlistEnabled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.helper.trans('counterparty_import.select_requisite')), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedRequisite,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRequisite) = $event)),
                      options: _ctx.requisiteOptions,
                      "custom-label": _ctx.requisiteLabel,
                      "track-by": "id",
                      "select-label": "Select",
                      placeholder: _ctx.helper.trans('labels.id'),
                      "open-direction": "bottom",
                      multiple: false,
                      searchable: true,
                      loading: _ctx.requisitesLoading,
                      "internal-search": false,
                      "clear-on-select": true,
                      "close-on-select": true,
                      "options-limit": 100,
                      "show-no-results": true,
                      onSearchChange: _ctx.asyncFindRequisites
                    }, null, 8, ["modelValue", "options", "custom-label", "placeholder", "loading", "onSearchChange"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.helper.trans('counterparty_import.select_store')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.selectedStore,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedStore) = $event)),
                  options: _ctx.storeOptions,
                  "custom-label": _ctx.storeLabel,
                  "track-by": "id",
                  "select-label": "Select",
                  placeholder: _ctx.helper.trans('labels.id'),
                  "open-direction": "bottom",
                  multiple: false,
                  searchable: true,
                  loading: _ctx.storesLoading,
                  "internal-search": false,
                  "clear-on-select": true,
                  "close-on-select": true,
                  "options-limit": 100,
                  "show-no-results": true,
                  onSearchChange: _ctx.asyncFindStores
                }, null, 8, ["modelValue", "options", "custom-label", "placeholder", "loading", "onSearchChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.helper.trans('counterparty_import.file_requirements_title')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("ul", _hoisted_11, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.helper.trans('counterparty_import.file_requirements_utf8')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.helper.trans('counterparty_import.file_requirements_line')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.helper.trans('counterparty_import.file_requirements_empty')), 1)
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("pre", { class: "bg-light border rounded p-2 mb-0 small" }, "user_abc123\nuser_def456\nuser_ghi789", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.helper.trans('counterparty_import.choose_file')), 1),
              _createElementVNode("div", _hoisted_14, [
                (!_ctx.selectedFile)
                  ? (_openBlock(), _createElementBlock("div", _mergeProps({
                      key: 0,
                      style: {"cursor":"pointer","border":"1px dashed"}
                    }, _ctx.dropzone.getRootProps(), { class: "payout-dropzone rounded border-secondary p-3 pt-4 pb-4 d-flex justify-content-center align-items-center" }), [
                      _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.dropzone.getInputProps())), null, 16),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.helper.trans('counterparty_import.dropzone')), 1)
                    ], 16))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-paperclip" }, null, -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedFile.name), 1),
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearFile && _ctx.clearFile(...args)), ["prevent"]))
                      }, _cache[7] || (_cache[7] = [
                        _createElementVNode("i", { class: "fa fa-times" }, null, -1)
                      ]))
                    ]))
              ])
            ]),
            (_ctx.result)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.helper.trans('counterparty_import.in_file', { n: _ctx.result.total })), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.importText('to_import', { n: _ctx.result.toImport })), 1),
                      (!_ctx.allowlistEnabled && _ctx.result.freeSlots !== null && _ctx.result.freeSlots !== undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.helper.trans('counterparty_import.free_slots', { n: _ctx.result.freeSlots })), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.result.valid && _ctx.result.toImport === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.importText('nothing_to_import')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.result.alreadyBound && _ctx.result.alreadyBound.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.importText('already_bound')), 1),
                          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.result.alreadyBound.join(', ')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.result.duplicatesInFile && _ctx.result.duplicatesInFile.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.helper.trans('counterparty_import.duplicates_in_file')), 1),
                          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.result.duplicatesInFile.join(', ')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.visibleErrors.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("ul", _hoisted_30, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleErrors, (error, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(_ctx.formatError(error)), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.importText('slot_hint')), 1)
          ])
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.close')), 1),
      _createElementVNode("button", {
        type: "button",
        disabled: !_ctx.canCheck || _ctx.isBusy,
        onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validateFile && _ctx.validateFile(...args)), ["prevent"])),
        class: "btn btn-outline-primary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.check_file')), 9, _hoisted_32),
      _createElementVNode("button", {
        type: "button",
        disabled: !_ctx.canImport || _ctx.isBusy,
        onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.importFile && _ctx.importFile(...args)), ["prevent"])),
        class: "btn btn-outline-primary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('labels.import')), 9, _hoisted_33)
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onUpdate:modelValue"]))
}